import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, msg: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, msg: (error && (error.message || String(error))) || "" };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error boundary caught:", error, info);
    try { this.setState({ stack: (info && info.componentStack ? String(info.componentStack).split("\n").slice(0, 4).join("\n") : "") }); } catch { /* ignore */ }
  }
  handleReset = () => {
    this.setState({ hasError: false });
  };
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="app-error-boundary" className="min-h-screen flex items-center justify-center p-6 bg-[#FDF8F0]">
          <div className="max-w-md w-full text-center rounded-2xl border border-[#E2DFD8] bg-white p-8">
            <div className="text-4xl mb-3">😕</div>
            <h1 className="font-head font-black text-xl text-[#1A1A1A]">Une erreur est survenue</h1>
            <p className="mt-2 text-sm text-[#75807A]">Pas d'inquiétude, vos informations ne sont pas perdues. Réessayez ou rechargez la page.</p>
            {this.state.msg ? (
              <pre data-testid="error-detail" className="mt-3 text-left text-[11px] leading-snug text-[#B4381F] bg-[#FEF1E7] border border-[#F26419]/30 rounded-lg p-2 overflow-auto max-h-32 whitespace-pre-wrap break-words">{this.state.msg}{this.state.stack ? "\n" + this.state.stack : ""}</pre>
            ) : null}
            <div className="mt-6 flex flex-col gap-2">
              <button data-testid="error-retry" onClick={this.handleReset} className="h-12 rounded-xl bg-[#F26419] hover:bg-[#D85312] text-white font-bold transition-colors">Réessayer</button>
              <button data-testid="error-reload" onClick={() => window.location.reload()} className="h-12 rounded-xl bg-white border border-[#E2DFD8] hover:border-[#D94F2B] text-[#1A1A1A] font-bold transition-colors">Recharger la page</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
